<template>
  <nav class="main-header navbar navbar-expand navbar-custom">

    <ul class="navbar-nav">
      <li class="nav-item d-lg-none">
        <a class="nav-link" href="#" role="button" @click.prevent="$emit('toggle-menu')">
          <i class="fas fa-bars"></i>
        </a>
      </li>
    </ul>

    <ul class="navbar-nav ms-auto">
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-user"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <i class="fas fa-user mr-2"></i> Mi Perfil
          </a>

          <div class="dropdown-divider"></div>
          <a href="#" @click.prevent="logout" class="dropdown-item">
            <i class="fas fa-sign-out-alt mr-2"></i> Salir
          </a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { logout as keycloakLogout } from '@/services/api/keycloak';

export default {
  name: 'NavBarComponent',
  emits: ['toggle-menu'],

  methods: {
    logout() {
      console.log('🚪 Iniciando logout...');
      try {
        localStorage.clear();

        const logoutRedirectUri = process.env.VUE_APP_KEYCLOAK_LOGOUT_REDIRECT || `${window.location.origin}/login`;

        keycloakLogout({ redirectUri: logoutRedirectUri });
      } catch (error) {
        console.error('Error logout:', error);
        
        window.location.href = '/login';
      }
    }
  }
};
</script>

<style scoped>
.navbar-custom {
  background-color: #011f5b;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.5);
  transition: background-color 0.3s ease, margin-left 0.3s ease-in-out, width 0.3s ease-in-out;
  border: none;
}

.navbar-custom .nav-link,
.navbar-custom .fas,
.navbar-custom .far {
  color: #ffffff !important;
}

@media (min-width: 768px) {
  .main-header {
    margin-left: 269px !important;
    width: calc(100% - 269px) !important;
  }

  .navbar-custom {
    background-color: #ffffff !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #dee2e6;
  }

  .navbar-custom .nav-link,
  .navbar-custom .fas,
  .navbar-custom .far {
    color: rgba(0, 0, 0, 0.5) !important;
  }

  .navbar-custom .nav-link:hover {
    color: rgba(0, 0, 0, 0.7) !important;
  }
}
</style>